import React from 'react'
import { Typography } from 'antd'

const Logo = () => (
  <Typography.Text strong>
    <i>FoodStyles Testing</i>
  </Typography.Text>
)
export default Logo
